import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DParametroPolitica } from '@dian/api-basicos-parametricas';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../../ingresos/ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';
declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});
const stepsList = [
/*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['708'] }
];

const tableStructure = [
    {id: 'pagador', title: 'Pagador'}, 
    {id: 'origen', title: 'Origen información'}, 
    {id: 'conceptoNombre', title: 'Concepto'}, 
    {id: 'rentaNombre', title: 'Tipo de renta'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  pagador: string;
  origen: string;
  concepto: string;
  conceptoNombre: string;
  tipoRenta: string;
  rentaNombre: string;
  numMeses: string;
  valor: string;
  seccionOrigen: string;
  limInterVivi:string;
  limMediPrep:string;
  limDepen:string; 
  lim4xmil:string;
  limInterIce:string;
  deshabilitarAcci:boolean
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-beneficios-tributarios-deducciones-especiales-modal',
  templateUrl: './beneficios-tributarios-deducciones-especiales-modal.component.html',
  styleUrls: ['./beneficios-tributarios-deducciones-especiales-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class BeneficiosTributariosDeduccionesEspecialesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean;
  listaTipoRenta:any=[];
  listaMeses: string[] =  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

 /*  listaConceptos:any= [
    {id: 1, nombre: 'Intereses de vivienda'},
    {id: 2, nombre: 'Medicina prepagada'},
    {id: 3, nombre: 'Dependientes'},
    {id: 4, nombre: 'GMF 4 X 1000'},
    {id: 5, nombre: 'Aportes cesantías'},
    {id: 6, nombre: 'Intereses educativos ICETEX'},
  ];
 */
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  uvt: string;
  listaConcDeduEspe = [];
  parametroTipoRenta:DParametroPolitica = new DParametroPolitica();
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<BeneficiosTributariosDeduccionesEspecialesModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    private _componentFactory: ComponentFactoryService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.obtenerEliminarDataTrabInd();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.inicializeTablaDesdeIngresos(true);
    this.validateShowSave();
    const valorParPolitica =  this.parametroTipoRenta.valor.split(','); 
    this.listaTipoRenta = this.listaTipoRenta.filter(item => valorParPolitica.includes(item.valor));
    this.listaTipoRenta.forEach(item => {
      item.mostrar = false;
    }); 

  }

  protected controlStep(direction: DirectionType): void {
  
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.pagador="";
    this.modelForm.concepto="0";
    this.modelForm.conceptoNombre="";
    this.modelForm.tipoRenta="0";
    this.modelForm.rentaNombre="";
    this.modelForm.numMeses="0";
    this.modelForm.valor="0";
    this.modelForm.limInterVivi="0";
    this.modelForm.limMediPrep="0";
    this.modelForm.origen="";
    this.modelForm.limDepen="0"; 
    this.modelForm.lim4xmil="0";
    this.modelForm.limInterIce="0";
    this.modelForm.seccionOrigen="";


  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_709 == undefined){

      this.model.doc.cuerpo.cc_id_709 = []; //pagador
      this.model.doc.cuerpo.cc_id_710 = []; //origen
      this.model.doc.cuerpo.cc_id_711 = []; //concepto
      this.model.doc.cuerpo.cc_id_712 = []; //tipoRenta
      this.model.doc.cuerpo.cc_id_713 = []; //valor
      this.model.doc.cuerpo.cc_id_716 = []; //numMeses
      this.model.doc.cuerpo.cc_id_719 = []; //limInterVivi
      this.model.doc.cuerpo.cc_id_720 = []; //limMediPrep
      this.model.doc.cuerpo.cc_id_721 = []; //seccionOrigen
      this.model.doc.cuerpo.cc_id_722 = []; //lim4xmil
      this.model.doc.cuerpo.cc_id_723 = []; //limInterIce
      this.model.doc.cuerpo.cc_id_715 = []; //limDepen
      this.model.doc.cuerpo.cs_id_714 = "0";//total
   
    }  
  }
  
  protected inicializeTablaDesdeIngresos(desdeSeccion:boolean){
   /*   this.model.doc.cuerpo.cc_id_311 = [];
    this.model.doc.cuerpo.cc_id_309 = [];
    this.model.doc.cuerpo.cc_id_302 = [];
    this.model.doc.cuerpo.cc_id_303 = [];  */

    if(this.model.doc.cuerpo.cc_id_311 != undefined 
      && this.model.doc.cuerpo.cc_id_311 != null){

        const posicionesCesantias = this.model.doc.cuerpo.cc_id_311
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);

        let indexTable = desdeSeccion ? this.dataSourceBody.length : this.model.doc.cuerpo.cc_id_709.length;
        if(posicionesCesantias.length > 0)
        {
          if(!desdeSeccion) this.inicializeForm();

          for(let i=0; i<posicionesCesantias.length; i++)
          {
            const indexCesantias = posicionesCesantias[i];
            //const existeValor = this.model.doc.cuerpo.cc_id_709.some(item => item.v === this.model.doc.cuerpo.cc_id_309[indexCesantias].v);
      
            //if(!existeValor){
              
              this.modelForm.id=indexTable;
              this.modelForm.pagador=this.model.doc.cuerpo.cc_id_309[indexCesantias].v;
              this.modelForm.origen=this.model.doc.cuerpo.cc_id_302[indexCesantias].v;
              this.modelForm.tipoRenta=this.model.doc.cuerpo.cc_id_303[indexCesantias].v;
              this.modelForm.rentaNombre= desdeSeccion ? this.listaTipoRenta[this.model.doc.cuerpo.cc_id_303[indexCesantias].v-1].nombre : ""; 
              this.modelForm.valor=this.model.doc.cuerpo.cc_id_311[indexCesantias].v;
              this.modelForm.concepto="5";
              this.modelForm.conceptoNombre= desdeSeccion ? this.listaConcDeduEspe[4].nombre : ""; 
              this.modelForm.seccionOrigen="I2";
              this.modelForm.deshabilitarAcci=true;

              this.calcularLim4xmil();
              this.calcularLimInterIce();
              this.calcularLimInterVivi();
              this.calcularLimMediPrep();
              this.calcularLimDepen();
              this.redondearFormData();
              if(desdeSeccion)
                this.dataSourceBody.push(this.modelForm);
              else
                this.addToModeloDesdeForm();
  
              this.inicializeForm();
              indexTable++;
            //}
            
          }
          
        }
      
        if(desdeSeccion)
          this.operacionCs714();
        else
        this.operacionCs714DesdeIngresos();       
    };
   
  }

  actualizarDataTrabInd(){
    if(this.model.doc.cuerpo.cc_id_721 != undefined 
      && this.model.doc.cuerpo.cc_id_721 != null){

        const posicionesTrabInd = this.model.doc.cuerpo.cc_id_721.reduce((acc, item, index) => {
          if (item.v == 'I2') {
              acc.push(index);
          }
          return acc;
      }, []);

      posicionesTrabInd.sort((a, b) => b - a).forEach(index => {
        this.model.doc.cuerpo.cc_id_709.splice(index, 1); //pagador
        this.model.doc.cuerpo.cc_id_710.splice(index, 1); //origen
        this.model.doc.cuerpo.cc_id_711.splice(index, 1); //concepto
        this.model.doc.cuerpo.cc_id_712.splice(index, 1); //tipoRenta
        this.model.doc.cuerpo.cc_id_713.splice(index, 1); //valor
        this.model.doc.cuerpo.cc_id_716.splice(index, 1); //numMeses
        this.model.doc.cuerpo.cc_id_719.splice(index, 1); //limInterVivi
        this.model.doc.cuerpo.cc_id_720.splice(index, 1); //limMediPrep
        this.model.doc.cuerpo.cc_id_721.splice(index, 1); //seccionOrigen
        this.model.doc.cuerpo.cc_id_722.splice(index, 1); //lim4xmil
        this.model.doc.cuerpo.cc_id_723.splice(index, 1); //limInterIce
        this.model.doc.cuerpo.cc_id_715.splice(index, 1); //limDepen
      });

      this.inicializeTablaDesdeIngresos(false);

    }
  }

  obtenerEliminarDataTrabInd(){
    if(this.model.doc.cuerpo.cc_id_721 != undefined 
      && this.model.doc.cuerpo.cc_id_721 != null){

        const posicionesTrabInd = this.model.doc.cuerpo.cc_id_721.reduce((acc, item, index) => {
          if (item.v == 'I2') {
              acc.push(index);
          }
          return acc;
      }, []);

      posicionesTrabInd.sort((a, b) => b - a).forEach(index => {
        this.model.doc.cuerpo.cc_id_709.splice(index, 1); //pagador
        this.model.doc.cuerpo.cc_id_710.splice(index, 1); //origen
        this.model.doc.cuerpo.cc_id_711.splice(index, 1); //concepto
        this.model.doc.cuerpo.cc_id_712.splice(index, 1); //tipoRenta
        this.model.doc.cuerpo.cc_id_713.splice(index, 1); //valor
        this.model.doc.cuerpo.cc_id_716.splice(index, 1); //numMeses
        this.model.doc.cuerpo.cc_id_719.splice(index, 1); //limInterVivi
        this.model.doc.cuerpo.cc_id_720.splice(index, 1); //limMediPrep
        this.model.doc.cuerpo.cc_id_721.splice(index, 1); //seccionOrigen
        this.model.doc.cuerpo.cc_id_722.splice(index, 1); //lim4xmil
        this.model.doc.cuerpo.cc_id_723.splice(index, 1); //limInterIce
        this.model.doc.cuerpo.cc_id_715.splice(index, 1); //limDepen
      });
    }
  }

 

  public operacionCs714(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    
    }
     
    if(suma)
      this.model.doc.cuerpo.cs_id_714 = suma;
    else
      this.model.doc.cuerpo.cs_id_714 = '0';  

  }

  public operacionCs714DesdeIngresos(){
    let suma = "0";
    for(let i=0; i<this.model.doc.cuerpo.cc_id_713.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cc_id_713[i].v, suma);
    
    }
     
    if(suma)
      this.model.doc.cuerpo.cs_id_714 = suma;
    else
      this.model.doc.cuerpo.cs_id_714 = '0'; 
  }

  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_709.length; i++){
      this.modelForm.id=i;
      this.modelForm.pagador=this.model.doc.cuerpo.cc_id_709[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_710[i].v;
      this.modelForm.concepto=this.model.doc.cuerpo.cc_id_711[i].v;
      if(this.model.doc.cuerpo.cc_id_711[i] && this.listaConcDeduEspe[this.model.doc.cuerpo.cc_id_711[i].v-1] )
        this.modelForm.conceptoNombre=this.listaConcDeduEspe[this.model.doc.cuerpo.cc_id_711[i].v-1].nombre;
      this.modelForm.tipoRenta=this.model.doc.cuerpo.cc_id_712[i].v;
      if(this.model.doc.cuerpo.cc_id_712[i] && this.listaTipoRenta[this.model.doc.cuerpo.cc_id_712[i].v-1])
        this.modelForm.rentaNombre=this.listaTipoRenta[this.model.doc.cuerpo.cc_id_712[i].v-1].nombre;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_713[i].v;
      if(this.model.doc.cuerpo.cc_id_716[i] && this.listaMeses[this.model.doc.cuerpo.cc_id_716[i].v-1])
        this.modelForm.numMeses=this.listaMeses[this.model.doc.cuerpo.cc_id_716[i].v-1].toString();
      this.modelForm.seccionOrigen=this.model.doc.cuerpo.cc_id_721[i].v;
      this.modelForm.limDepen=this.model.doc.cuerpo.cc_id_715[i].v;
      this.modelForm.limMediPrep=this.model.doc.cuerpo.cc_id_720[i].v;
      this.modelForm.lim4xmil=this.model.doc.cuerpo.cc_id_722[i].v;
      this.modelForm.limInterVivi=this.model.doc.cuerpo.cc_id_719[i].v;
      this.modelForm.limInterIce=this.model.doc.cuerpo.cc_id_723[i].v;
      this.modelForm.deshabilitarAcci=this.modelForm.seccionOrigen != "" ? true : false;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

protected initializeTablaDesdeSugerida()
{
  let indexModel = this.model.doc.cuerpo.cc_id_709.length;

  if(indexModel==0){
    const fieldsRecovery = ['VAR_1068'];
    const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);

    if(resData)
      {
        for(let i=0; i<resData.length; i++){
          for(let j=0; j<resData[i].item.value.length; j++){
            
            this.modelForm.id=indexModel;
            this.modelForm.valor=String(resData[i].item.value[j]);
            this.modelForm.origen="0";
            this.modelForm.pagador=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.concepto="5"
            this.modelForm.conceptoNombre= this.listaConcDeduEspe[Number(this.modelForm.concepto)-1].nombre; 
            this.modelForm.tipoRenta="4";
            this.modelForm.rentaNombre= this.listaTipoRenta[Number(this.modelForm.tipoRenta)-1].nombre; 
            this.modelForm.deshabilitarAcci=false;
            this.calcularLim4xmil();
            this.calcularLimInterIce();
            this.calcularLimInterVivi();
            this.calcularLimMediPrep();
            this.calcularLimDepen();
            this.redondearFormData();
            this.reloadListTipoRent();
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          
          }
        }
      }
  }

  this.operacionCs714();
}

  public editModeloDesdeForm(){
    const tipoRenta =  this.modelForm.concepto == '6' ? '1' : this.modelForm.tipoRenta.toString();
    
    this.model.doc.cuerpo.cc_id_709[this.modelForm.id].v=this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_710[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_711[this.modelForm.id].v=this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_712[this.modelForm.id].v=tipoRenta;
    this.model.doc.cuerpo.cc_id_713[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_716[this.modelForm.id].v=this.modelForm.numMeses.toString();
    this.model.doc.cuerpo.cc_id_719[this.modelForm.id].v=this.modelForm.limInterVivi.toString();
    this.model.doc.cuerpo.cc_id_720[this.modelForm.id].v=this.modelForm.limMediPrep.toString();
    this.model.doc.cuerpo.cc_id_715[this.modelForm.id].v=this.modelForm.limDepen.toString();
    this.model.doc.cuerpo.cc_id_721[this.modelForm.id].v=this.modelForm.seccionOrigen.toString();
    this.model.doc.cuerpo.cc_id_722[this.modelForm.id].v=this.modelForm.lim4xmil.toString();
    this.model.doc.cuerpo.cc_id_723[this.modelForm.id].v=this.modelForm.limInterIce.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    const tipoRenta =  this.modelForm.concepto == '6' ? '1' : this.modelForm.tipoRenta.toString();
    this.model.doc.cuerpo.cc_id_709.push({it: i, v:this.modelForm.pagador});
    this.model.doc.cuerpo.cc_id_710.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_711.push({it: i, v:this.modelForm.concepto.toString()});
    this.model.doc.cuerpo.cc_id_712.push({it: i, v:tipoRenta});
    this.model.doc.cuerpo.cc_id_713.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_716.push({it: i, v:this.modelForm.numMeses.toString()});
    this.model.doc.cuerpo.cc_id_719.push({it: i, v:this.modelForm.limInterVivi.toString()});
    this.model.doc.cuerpo.cc_id_720.push({it: i, v:this.modelForm.limMediPrep.toString()});
    this.model.doc.cuerpo.cc_id_721.push({it: i, v:this.modelForm.seccionOrigen.toString()});
    this.model.doc.cuerpo.cc_id_715.push({it: i, v:this.modelForm.limDepen.toString()});
    this.model.doc.cuerpo.cc_id_722.push({it: i, v:this.modelForm.lim4xmil.toString()});
    this.model.doc.cuerpo.cc_id_723.push({it: i, v:this.modelForm.limInterIce.toString()});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_709.splice(index,1);
    this.model.doc.cuerpo.cc_id_710.splice(index,1);
    this.model.doc.cuerpo.cc_id_711.splice(index,1);
    this.model.doc.cuerpo.cc_id_712.splice(index,1);
    this.model.doc.cuerpo.cc_id_713.splice(index,1);
    this.model.doc.cuerpo.cc_id_716.splice(index,1);
    this.model.doc.cuerpo.cc_id_719.splice(index,1);
    this.model.doc.cuerpo.cc_id_720.splice(index,1);
    this.model.doc.cuerpo.cc_id_721.splice(index,1);
    this.model.doc.cuerpo.cc_id_722.splice(index,1);
    this.model.doc.cuerpo.cc_id_723.splice(index,1);
    this.model.doc.cuerpo.cc_id_715.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_709.length;i++){
      this.model.doc.cuerpo.cc_id_709[i].it=i+1;
      this.model.doc.cuerpo.cc_id_710[i].it=i+1;
      this.model.doc.cuerpo.cc_id_711[i].it=i+1;
      this.model.doc.cuerpo.cc_id_712[i].it=i+1;
      this.model.doc.cuerpo.cc_id_713[i].it=i+1;
      this.model.doc.cuerpo.cc_id_716[i].it=i+1;
      this.model.doc.cuerpo.cc_id_719[i].it=i+1;
      this.model.doc.cuerpo.cc_id_720[i].it=i+1;
      this.model.doc.cuerpo.cc_id_721[i].it=i+1;
      this.model.doc.cuerpo.cc_id_722[i].it=i+1;
      this.model.doc.cuerpo.cc_id_723[i].it=i+1;
      this.model.doc.cuerpo.cc_id_715[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.pagador==undefined || this.modelForm.pagador==null || this.modelForm.pagador.trim()=="" ||
          this.modelForm.tipoRenta==undefined || this.modelForm.tipoRenta==null  || this.modelForm.tipoRenta=="0" || 
          this.modelForm.concepto==undefined || this.modelForm.concepto==null  || this.modelForm.concepto=="0" ||  
         this.modelForm.valor==undefined || this.modelForm.valor==null || 
          this.modelForm.origen==undefined || this.modelForm.origen==null ||
          ((this.modelForm.numMeses==undefined || this.modelForm.numMeses==null  || this.modelForm.numMeses=="0") && (this.modelForm.concepto=="3" || this.modelForm.concepto=="6")) 
  }

  validateHasDataDepen():string[]{
    return this.dataSourceBody
    .filter(item => item.concepto === "6") // Filtra los elementos con concepto "6"
    .map(item => item.id); // Extrae el id de cada elemento filtrado
  }

  validateHasDataInterVivi():string[]{
    return this.dataSourceBody
    .filter(item => item.concepto === "1") // Filtra los elementos con concepto "6"
    .map(item => item.id); // Extrae el id de cada elemento filtrado
  }

  
  validateHasDataCesaRentSinCost():boolean{
    return this.dataSourceBody.some(item => item.concepto=="5" && (item.tipoRenta=="1" || item.tipoRenta=="2"));
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    this.modelForm.limInterVivi=this.dutilidades.redondearValorMoneda(this.modelForm.limInterVivi.toString(),true);
    this.modelForm.limMediPrep=this.dutilidades.redondearValorMoneda(this.modelForm.limMediPrep.toString(),true);
     this.modelForm.limDepen=this.dutilidades.redondearValorMoneda(this.modelForm.limDepen.toString(),true); 
    this.modelForm.lim4xmil=this.dutilidades.redondearValorMoneda(this.modelForm.lim4xmil.toString(),true);
    this.modelForm.limInterIce=this.dutilidades.redondearValorMoneda(this.modelForm.limInterIce.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

  }


  reloadListTipoRent(){

     /*  
      "1","Intereses préstamos compra vivienda",
      "2","Intereses préstamos ICETEX",
      "3","Medicina prepagada y seguro de salud",
      "4","GMF 4 X 1000",
      "5","Aportes a Cesantías",
      "6","Dependientes",
      "7","25% Rentas de Trabajo con Costos"
      excel:
      1 - Intereses de vivienda
      2 - Medicina prepagada
      3 - Dependientes
      4 - GMF 4 X 1,000
      5 - Aportes Cesantías
      6 - intereses educativos ICETEX
      7 - 25% Rentas de Trabajo con costos

      1 - Rentas de trabajo sin costo
2 - Rentas de trabajo con costo
3 - Rentas de capital
4 -  Rentas no laborales
5 - Pensión
6 - Dividendos
7 - GO

 */
    const concepto = this.modelForm.concepto;
    this.listaTipoRenta.forEach(item => {
      item.mostrar = false;
      if(concepto=="1"){
        item.mostrar=true;
      }else if(concepto=="2" || concepto=="4"  && (item.valor!= "4")){
        item.mostrar=true;
      }
      else if(concepto=="3" && (item.valor=="1" || item.valor=="2")){
        item.mostrar=true;
      }else if(concepto=="6" && (item.valor=="1")){
        item.mostrar=true;
      }else if(concepto=="5" && (/* item.valor=="1" || item.valor=="2" || */ item.valor=="3" || item.valor=="4")){
       /*  if(item.valor=="1" || item.valor=="2"){
          if(this.validateHasDataCesaRentSinCost() && this.operacionTabla==this.OPERACION_AGREGAR){
            item.mostrar=false;
          }else
            item.mostrar=true;
        }else */
          item.mostrar=true;
      }
    });
      

  }

  reloadListMeses(){
    const concepto = this.modelForm.concepto;
    if(concepto != "3" && concepto != "6"){
      this.modelForm.numMeses="0";
    }

  }

  calcularLimMediPrep(){
    const valor = this.modelForm.valor;
    const valorUVT = this.convertirPesosUvt(valor);
    const limInteMediPrep = "16";
    const limInteMediPrepPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limInteMediPrep, true);
    const tipoRenta = this.modelForm.tipoRenta;
    const numMeses = this.modelForm.numMeses;
    const valorxNumMeses = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, numMeses, true);
    const numMesesxLimInteMediPrepPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, numMeses, limInteMediPrepPesos, true);

    if(tipoRenta=="1"){
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorxNumMeses, numMesesxLimInteMediPrepPesos)){ 
        this.modelForm.limMediPrep=valorxNumMeses;
      }else{
        this.modelForm.limMediPrep=numMesesxLimInteMediPrepPesos;
      }
    }else{
      this.modelForm.limMediPrep="";

    }
    
  }

  calcularLimInterVivi(){
    const valor = this.modelForm.valor;
    const valorUVT = this.convertirPesosUvt(valor);
    const limInteViviendaUVT = "1200";
    const limInteViviendaPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limInteViviendaUVT, true);
 
     if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, valorUVT, limInteViviendaUVT)){ 
      this.modelForm.limInterVivi=valor;
    }else{
      this.modelForm.limInterVivi=limInteViviendaPesos
    } 
  }

  calcularLim4xmil(){
    const valor = this.modelForm.valor;
    const tipoRenta = this.modelForm.tipoRenta;
    const concepto = this.modelForm.concepto;
    if((tipoRenta=="1" || tipoRenta=="2" || tipoRenta=="3") && concepto=="4"){
      this.modelForm.lim4xmil=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, "0.5");
    }else{
      this.modelForm.lim4xmil="";
    }
  }

  calcularLimInterIce(){
    const concepto = this.modelForm.concepto; 
    
    if(concepto=="2"){
      const valor = this.modelForm.valor; 
      const valorUVT = this.convertirPesosUvt(valor);
      const limInterIceUVT = "100";
      const limInterIcePesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limInterIceUVT, true);
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limInterIceUVT))
        this.modelForm.limInterIce=valor;
      else
      this.modelForm.limInterIce=limInterIcePesos;
    }else
      this.modelForm.limInterIce="";
    
  }

  public calcularLimDepen(){
    const concepto = this.modelForm.concepto; 
    const renta = this.modelForm.tipoRenta;
    const limDedDepenUVT = "32";
    const limDedDepenPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limDedDepenUVT, true);
    const limDedDepenPesosxNumMeses = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limDedDepenPesos, this.modelForm.numMeses, true);
    
    if((renta == "1" || renta == "2") && concepto=="6"){

     /*  let suma279 = "0";
      for(let i=0; i<this.model.doc.cuerpo.cc_id_279.length; i++){
        suma279 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cc_id_279[i].v, suma279);
      } */

      /* let suma304 = "0";
      for(let i=0; i<this.model.doc.cuerpo.cc_id_305.length; i++){
        suma304 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cc_id_305[i].v, suma304);
      } */

      

      const suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cs_id_280, this.model.doc.cuerpo.cs_id_305);
      const sumaMult = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, suma, "0.10", true);

      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, sumaMult, limDedDepenPesosxNumMeses)){
        this.modelForm.limDepen=sumaMult;
      }else{
        this.modelForm.limDepen=limDedDepenPesosxNumMeses;
      }

    }else
      this.modelForm.limDepen="";
  }

  calcularValorItem(){

   /*  
      "1","Intereses préstamos compra vivienda",
      "2","Intereses préstamos ICETEX",
      "3","Medicina prepagada y seguro de salud",
      "4","GMF 4 X 1000",
      "5","Aportes a Cesantías",
      "6","Dependientes",
      "7","25% Rentas de Trabajo con Costos"
       excel:
      1 - Intereses de vivienda
      2 - Medicina prepagada
      3 - Dependientes
      4 - GMF 4 X 1,000
      5 - Aportes Cesantías
      6 - intereses educativos ICETEX
      7 - 25% Rentas de Trabajo con costos
      ----------------

 */
    const valor = this.modelForm.valor;
    const concepto = this.modelForm.concepto; 
    const renta = this.modelForm.tipoRenta;

    if(concepto=="1" && (renta=="1" || renta=="2" || renta=="3" || renta=="4")){
      const limInteVivi = this.modelForm.limInterVivi;
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, limInteVivi)){
        this.modelForm.valor=valor;
      }else{
        this.modelForm.valor=limInteVivi;
      }
    }else if(concepto=="2"  && (renta=="1" || renta=="2" || renta=="3")){
      const limInterIce = this.modelForm.limInterIce;
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, limInterIce)){
        this.modelForm.valor=valor;
      }else{
        this.modelForm.valor=limInterIce;
      }
    }else if(concepto=="3" && (renta=="1" || renta=="2")){
      const limMediPrep = this.modelForm.limMediPrep;
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, limMediPrep)){
        this.modelForm.valor=valor;
      }else{
        this.modelForm.valor=limMediPrep;
      }
    }else if(concepto=="4" && (renta=="1" || renta=="2" || renta=="3")){
      const lim4xmil = this.modelForm.lim4xmil;
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, lim4xmil)){
        this.modelForm.valor=valor;
      }else{
        this.modelForm.valor=lim4xmil;
      }
    }else if(concepto=="5" && renta!=""){
      let cas307 = "0";
      const cas307Obj = this.model.doc.cuerpo.cc_id_307.find(item => parseFloat(item.v) > 0 && item.v != "");

      let suma311 = "0";
      for(let i=0; i<this.model.doc.cuerpo.cc_id_311.length; i++){
        suma311 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cc_id_311[i].v, suma311);
      }
      
      if(cas307Obj && cas307Obj != undefined) cas307 = cas307Obj.v;
      
     /*  if(renta == "1"){
        let sumacc291 = "0";
        for(let i=0; i<this.model.doc.cuerpo.cc_id_291.length; i++){
          sumacc291 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cc_id_291[i].v, suma311);
        }
        const cas296 = this.model.doc.cuerpo.cc_id_296 != undefined && this.model.doc.cuerpo.cc_id_296.length > 0 ? this.model.doc.cuerpo.cc_id_296[0].v:"0";

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, sumacc291, cas296))
          this.modelForm.valor = sumacc291;
        else
          this.modelForm.valor = cas296;
        
      } */
      if(renta == "2"){
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma311, cas307))
          this.modelForm.valor=suma311;
        else
          this.modelForm.valor=cas307;
      }
     
      if(renta == "2"|| renta == "3" || renta == "4"){
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, cas307))
          this.modelForm.valor=valor;
        else
        this.modelForm.valor=cas307;
      }
      
      let limCesant = "0";
        for(let i=0; i<this.model.doc.cuerpo.cc_id_303.length; i++){
          if(this.model.doc.cuerpo.cc_id_303[i].v == "1"){
            if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cc_id_307[i].v, "0")){
              limCesant = this.model.doc.cuerpo.cc_id_307[i].v;
              break;
            }
          } 
        }
      if(renta == "2"){
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma311, limCesant))
          this.modelForm.valor=suma311;
        else
          this.modelForm.valor=limCesant;

      }

      /*if(renta == "3"){
        const cas328 = this.model.doc.cuerpo.cs_id_328;
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas328, cas307))
          this.modelForm.valor=cas328;
        else
          this.modelForm.valor=cas307;
      }

      if(renta == "4"){
        const cas343 = this.model.doc.cuerpo.cs_id_343;
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas343, cas307))
          this.modelForm.valor=cas343;
        else
          this.modelForm.valor=cas307;
      } */
      
    }else if(concepto=="6" && (renta=="1" || renta=="2")){
      const limDepen = this.modelForm.limDepen;
      this.modelForm.valor=limDepen;
    }else if(concepto=="7" && renta =="2"){
      let cas322 = "0";
      const cas322Obj = this.model.doc.cuerpo.cc_id_322.find(item => parseFloat(item.v) > 0 && item.v != "");
      if(cas322Obj && cas322Obj != undefined) cas322 = cas322Obj.v;
      this.modelForm.valor = cas322;
    }

    this.redondearFormData();
      
  }

  calcularLimitantes(){
    this.calcularLimInterVivi();
    this.calcularLimMediPrep();
    this.calcularLim4xmil();
    this.calcularLimInterIce();
    this.calcularLimDepen()

    this.redondearFormData();
    this.calcularValorItem();
  }

  
  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.uvt);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }

  saveItem(): void {
    const mensajeDedRegi = "Usted ya tiene esta deducción registrada";
    const registrosDependientes = this.validateHasDataDepen();
    const registrosInterViv = this.validateHasDataInterVivi();

    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else if(this.modelForm.concepto=="6" && this.operacionTabla==this.OPERACION_AGREGAR && registrosDependientes.length>0){ //si agrega un dependiente y ya tiene uno
      let dialogError = this.dNotificacionServicio.mostrarDialogoError(mensajeDedRegi+" :Dependientes" );
      return;
    }else if(this.modelForm.concepto=="1" && this.operacionTabla==this.OPERACION_AGREGAR && registrosInterViv.length>0){ //si agrega intereses de vivienda y ya tiene una
      let dialogError = this.dNotificacionServicio.mostrarDialogoError(mensajeDedRegi+" :Intereses de vivienda" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        if(this.modelForm.concepto=="6" && registrosDependientes.length>1){
          this.modelForm.concepto = null;
          this.modelForm.conceptoNombre = null;
          let dialogError = this.dNotificacionServicio.mostrarDialogoError(mensajeDedRegi+" :Dependientes" );
          return;
        }

          if(this.modelForm.concepto=="1" && registrosInterViv.length>1){
            this.modelForm.concepto = null;
            this.modelForm.conceptoNombre = null;
            let dialogError = this.dNotificacionServicio.mostrarDialogoError(mensajeDedRegi+" :Dependientes" );
            return;
          }
        const existeValor = this.model.doc.cuerpo.cc_id_709.some(item => item.v === this.modelForm.pagador);
        this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta)-1].nombre;
        this.modelForm.conceptoNombre = this.listaConcDeduEspe[Number(this.modelForm.concepto)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
       
        
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_709.length;
        this.modelForm.origen = "2";
      //  this.modelForm.reportante = "Contribuyente";
        this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta)-1].nombre;
        this.modelForm.conceptoNombre = this.listaConcDeduEspe[Number(this.modelForm.concepto)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs714();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs714();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      
      this.modelForm = this.dataSourceBody[index];
      this.reloadListTipoRent();
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }



  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs714();

    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_709 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs714();
   
    this.saveModel.emit(true); 
    this.closeModal();   
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-tributarios-deducciones-especiales/beneficios-tributarios-deducciones-especiales-modal.component.ts